import { View } from 'foundations-components/components/View';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyOverviewCard = ({
  illustration = 'empty-state-charts',
  illustrationProps = {
    width: 180
  },
  children,
  maxInlineSize = '300px',
  paddingBlockEnd,
  marginInline = 'auto'
}) => /*#__PURE__*/_jsx(View, {
  marginInline: marginInline,
  maxInlineSize: maxInlineSize,
  paddingBlockEnd: paddingBlockEnd,
  children: /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: illustration,
    illustrationProps: illustrationProps,
    children: children
  })
});
export default EmptyOverviewCard;